import React from 'react';

interface IProps {
  className?: string;
  title?: string;
  children: React.ReactNode;
}

export const FooterList: React.FC<IProps> = ({ className, title, children }) => (
  <div
    className={`mb-6 flex w-full flex-col text-center text-base last:mb-0 md:mb-0 md:w-60 md:text-left ${className} `}>
    <span className='mb-4 font-semibold text-neutral-800'>{title}</span>
    <div className='flex flex-col gap-2 font-medium text-neutral-700'>{children}</div>
  </div>
);
